import { render, staticRenderFns } from "./certificates.vue?vue&type=template&id=251fe650&scoped=true"
import script from "./certificates.vue?vue&type=script&lang=js"
export * from "./certificates.vue?vue&type=script&lang=js"
import style0 from "./certificates.vue?vue&type=style&index=0&id=251fe650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251fe650",
  null
  
)

export default component.exports